var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variant)?_c('inventory-query',{attrs:{"filter":{ sku: _vm.variant.sku }},on:{"data":_vm.onInventory}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }